<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="element">
          <div class="search-box-container">
            <div class="nav" style="border-radius: 8px 8px 0 0">
              <h1>
                Assistentes
                <span v-if="!listLoading && !listError">({{ assistantCount }})</span>
              </h1>
              <div style="display: flex; gap: 20px">
                <input
                  id="searchInput"
                  type="text"
                  class="form-control search-field"
                  placeholder="Buscar por nome/email..."
                  @input="debounceSearch"
                  :class="{ disabled: listLoading }"
                  :disabled="listLoading"
                />

                <select
                  class="form-select"
                  @change="selectNewStatus($event)"
                  :disabled="listLoading"
                >
                  <option value="">Todos</option>
                  <option value="1">Em análise</option>
                  <option value="2">Ativos</option>
                  <option value="3">Desativados</option>
                  <option value="4">Assinantes</option>
                </select>
              </div>
            </div>
          </div>
          <div class="project-list">
            <div
              class="post_project post_project-active"
              style="padding: 20px; height: auto"
              :class="{ nopro: assistants && assistants.length === 0 }"
            >
              <div class="loading_container" v-if="listLoading" style="height: 200px">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
              <div v-else-if="listError" class="create-project">
                <div class="card">
                  <div class="card-body">
                    <h2 class="text-danger">Erro</h2>
                    <p class="text-danger">
                      Ocorreu um erro ao atualizar a lista de assistentes.<br />
                      Por favor, tente novamente.
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="create-project"
                v-else-if="!assistants || assistants.length === 0"
              >
                <div class="card">
                  <img src="assets/img/project.png" alt="" />
                  <div class="card-body">
                    <h2>Nenhum perfil encontrado</h2>
                  </div>
                </div>
              </div>
              <div class="active-project" style="padding: 0" v-else>
                <a
                  class="card"
                  style="position: static"
                  v-for="assistant in assistants"
                  :key="assistant.id"
                  :href="'/assistente/' + assistant.id"
                >
                  <div class="name">
                    <p>
                      Nome <br />
                      <span>{{ assistant.name }}</span>
                    </p>
                  </div>
                  <div class="date">
                    <p>
                      Data de registro <br />
                      <span>{{ formatTimestamp(assistant.registration_timestamp) }}</span>
                    </p>
                  </div>
                  <div class="count">
                    <p>
                      Plano <br />
                      <span>{{ assistant.plan }}</span>
                    </p>
                  </div>
                  <div class="status">
                    <p>
                      Status <br />
                      <span :class="getTextStatusClass(assistant.status)">
                        {{ formatAssistantStatus(assistant.status) }}</span
                      >
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

import debounce from "lodash.debounce";

const debouncedHandler = debounce((event, func) => {
  func(event.target.value);
}, 500);

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "AssistantListPage");
    this.loadAssistants();
  },

  beforeUnmount() {
    debouncedHandler.cancel();
  },

  data() {
    return {
      assistants: null,
      selectedStatus: null,
      filter: null,
      listLoading: false,
      listError: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    assistantCount() {
      if (this.assistants) {
        return this.assistants.length;
      }
      return 0;
    },
  },

  methods: {
    async loadAssistants() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AdminManager.getAssistants();
        let profile = response.profile;
        this.assistants = response.assistants;
        this.$store.commit("setActiveUser", profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, this.$route.fullPath.replace(/^\/+/, ""));
      }
    },

    async selectNewStatus(event) {
      this.selectedStatus = event.target.value;
      this.searchAssistants();
    },

    debounceSearch(e) {
      debouncedHandler(e, async () => {
        await this.searchAssistants();
        this.$nextTick(() => {
          $("#searchInput").focus();
        });
      });
    },

    async searchAssistants() {
      this.listLoading = true;
      this.listError = null;
      try {
        let response = await AdminManager.getAssistants(
          this.selectedStatus,
          $("#searchInput").val()
        );
        this.assistants = response.assistants;
      } catch (err) {
        console.log(err);
        this.listError = err;
      } finally {
        this.listLoading = false;
      }
    },
  },
};
</script>
